import React from "react";
import FormalizerInputField from "../InputField";
import * as style from "./style.module.scss";

type Props = {
    name: string;
};

const FormalizerCheckboxField = ({ name }: Props) => {
    return (
        <div className={style.inputWrapper}>
            <FormalizerInputField name={name} role="checkbox" type="checkbox" />
        </div>
    );
};

export default FormalizerCheckboxField;
